import util from '../lib/util';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class Address extends Base implements EntityType {
    addressId: uuid;
    placeId?: string | null;
    label: string;
    street?: string | null;
    unit?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    county?: string | null;
    country?: string | null;
    canContact: boolean;
    isPrimary: boolean;
    isCurrent: boolean;
    notes?: string | null;
    constructor(doc: typeof Address | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            addressId: genUUID(),
            label: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "address";
        // @ts-ignore
        this.addressId = doc._addressId || doc.addressId || doc.addressid || genUUID();
        // @ts-ignore
        this.placeId = doc._placeId || doc.placeId || doc.placeid || null;
        // @ts-ignore
        this.label = doc._label || doc.label || null;
        // @ts-ignore
        this.street = doc._street || doc.street || null;
        // @ts-ignore
        this.unit = doc._unit || doc.unit || null;
        // @ts-ignore
        this.city = doc._city || doc.city || null;
        // @ts-ignore
        this.state = doc._state || doc.state || null;
        // @ts-ignore
        this.zip = doc._zip || doc.zip || null;
        // @ts-ignore
        this.county = doc._county || doc.county || null;
        // @ts-ignore
        this.country = doc._country || doc.country || null;
        // @ts-ignore
        this.canContact = util.defaultBoolean([doc.canContact, doc._canContact, doc.cancontact, true]);
        // @ts-ignore
        this.isPrimary = util.defaultBoolean([doc.isPrimary, doc._isPrimary, doc.isprimary, false]);
        // @ts-ignore
        this.isCurrent = util.defaultBoolean([doc.isCurrent, doc._isCurrent, doc.iscurrent, true]);
        // @ts-ignore
        this.notes = doc._notes || doc.notes || null;
    }
    get id(): uuid { return this.addressId; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique ID for this address"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","mergeStrategy":"immutable","comment":"Associated firm"}]; }
    toLowerCase() { return this.addressId; }
    displayFn() { return `${this.label}: ${this.street}, ${this.city}, ${this.state} ${this.zip}`; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): Address[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'address',
    table: 'ADDRESS',
    comment: 'A physical (mailing) address belonging to a contact or other firm entity. Each address has a user-supplied label (e.g. Home, Work), optional Google Place ID for geocoding, and flags indicating whether the contact can be reached there, whether it is the primary address, and whether it is where they currently reside. Address changes are synced to the payment processor after save.',
    fields: {
        addressId: {type: 'uuid', required: true, pk: true, default: '__UUID__', comment: 'Unique ID for this address'},
        placeId: {type: 'string', required: false, comment: "Google Place ID"},
        label: {type: 'string', required: true, comment: 'A non-unique label for the address, e.g. Home'},
        street: {type: 'string', comment: 'e.g. 1415 Longshanks Dr.'},
        unit: {type: 'string', comment: 'Unit number if an apartment or business'},
        city: {type: 'string', comment: 'City name'},
        state: {type: 'string', comment: 'State or Province'},
        zip: {type: 'string', comment: 'ZIP code'},
        county: {type: 'string', comment: 'The county (for Canadian addresses, the judicial district)'},
        country: {type: 'string', comment: 'Country code, e.g. US or MX'},
        canContact: {type: 'boolean', default: true, comment: 'Can the person/entity be contacted with this address?'},
        isPrimary: {type: 'boolean', default: false, comment: 'Is this the primary address for this contact?'},
        isCurrent: {type: 'boolean', default: true, comment: 'Is this the address where the person currently resides?'},
        notes: {type: 'string', required: false, comment: 'Notes on the address (to differentiate)'}
    },
    displayFn: "`${this.label}: ${this.street}, ${this.city}, ${this.state} ${this.zip}`",
    indexes: [
        {name: 'notDeleted', fn: a => a.status !== 'D'}
    ],
    maps: [
        {
            name: 'entityId', keysFn: a => a.entityId, presentFn: (a, k) => a.entityId === k && a.status !== 'D'
        }
    ],
    hooks: [
        {when: 'after', appliesTo: 'save', method: 'updatePaymentProcessor', async: true}
    ]
});
    }
}
export default Address;
